module.exports = __webpack_public_path__ + "static/media/03_05_02.6b986eee.png";